import { render, staticRenderFns } from "./bo-mobile-catalog-list.vue?vue&type=template&id=31b89a3a"
import script from "./bo-mobile-catalog-list.vue?vue&type=script&lang=js"
export * from "./bo-mobile-catalog-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports